var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.page_type === 'basket')?_c('Basket'):_vm._e(),(_vm.page_type === 'order')?_c('Order'):(_vm.page_type === 'thank-you')?_c('ThankYou'):_vm._e(),(_vm.page_type === 'contact-us')?_c('ContactPage'):_vm._e(),(_vm.page_type === 'about')?_c('About'):_vm._e(),(_vm.$route.path.includes('legal-page'))?_c('LegalPage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }